export default "__VITE_ASSET__CIijkIXa__"